/**
 * @generated SignedSource<<ac1316217f74edd0db481790f6c04f13>>
 * @relayHash b8a2613526e645f6a3643b08f3e887dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 547ca1ad44eb417eb914e8fef9e36525294b63c74b4061a09d60cd80efbd14cb

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GlobalThemePreferenceQuery$variables = {
  accountId: string;
};
export type GlobalThemePreferenceQuery$data = {
  readonly settings_userPreferencesGlobal: {
    readonly theme: string | null | undefined;
  } | null | undefined;
};
export type GlobalThemePreferenceQuery = {
  response: GlobalThemePreferenceQuery$data;
  variables: GlobalThemePreferenceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      }
    ],
    "concreteType": "SettingsUserPreferences",
    "kind": "LinkedField",
    "name": "settings_userPreferencesGlobal",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalThemePreferenceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalThemePreferenceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b8a2613526e645f6a3643b08f3e887dd",
    "id": "547ca1ad44eb417eb914e8fef9e36525294b63c74b4061a09d60cd80efbd14cb",
    "metadata": {},
    "name": "GlobalThemePreferenceQuery",
    "operationKind": "query",
    "text": "query GlobalThemePreferenceQuery($accountId:ID!){settings_userPreferencesGlobal(accountId:$accountId){theme}}"
  }
};
})();

(node as any).hash = "c8d4cb97c65faed29a84ec972a289552";

export default node;
